var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { ListService, Predicate } from '../../../../component/list/list.service';
import { AuAction } from '../../../../action/au.action';
import { MessageService } from '../../../../service/message.service';
import { PageService } from '../../../../models/page.service';
import { SearchComponent } from '../../../../component/list/search.component';
import { ItemBase } from '../../../../models/item/item-base';
import { ColumnService } from '../../../../items/columns/column/column.service';
import { Select2ajaxService } from '../../../../items/columns/select/select2ajax.service';
import { KtsTaskConditionService } from '../../items/columns/task/task-condition.service';
import { KtsDateTimeService } from '../../items/columns/date/datetime.service';
var KtsSearchComponent = /** @class */ (function (_super) {
    __extends(KtsSearchComponent, _super);
    function KtsSearchComponent(router, route, logger, action, message, page, service, columnService, s2Service, taskCondService, datetimeService) {
        var _this = _super.call(this, router, route, logger, action, message, page, service, columnService, s2Service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.columnService = columnService;
        _this.s2Service = s2Service;
        _this.taskCondService = taskCondService;
        _this.datetimeService = datetimeService;
        _this.orgRec = {};
        return _this;
    }
    KtsSearchComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.orgRec = Object.assign({}, this.rec);
    };
    KtsSearchComponent.prototype.setUnsubscribe = function () {
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    KtsSearchComponent.prototype.onSubscribe = function (data) {
        _super.prototype.onSubscribe.call(this, data);
        if (typeof data.project_m_id !== 'undefined') {
            this.taskCondService.setProjectMId(data.project_m_id);
        }
        this.rec = Object.assign({}, this.orgRec);
    };
    KtsSearchComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    KtsSearchComponent.prototype.onChange = function (e) {
        _super.prototype.onChange.call(this, e);
        this.orgRec = Object.assign({}, this.rec);
    };
    KtsSearchComponent.prototype.setPredicateList = function () {
        var _this = this;
        this.predicateList = [];
        this.conddisp = [];
        var _loop_1 = function (col) {
            var disp = false;
            if (col.items) {
                for (var _i = 0, _a = col.items; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this_1.formatDateTime(item.key, item.controlType, item);
                    disp = disp || this_1.setPredicate(item, this_1.rec[item.key]);
                }
            }
            else {
                var k_1 = col.key;
                if (col.controlType === 'textOperator') {
                    disp = this_1.setPredicate(Object.assign(new ItemBase(), col, { controlType: 'text' }), this_1.rec[k_1], this_1.rec['$operator.' + k_1]);
                }
                else if (col.controlType === 'numberOperator' || col.controlType === 'dateOperator' || col.controlType === 'timeOperator' || col.controlType === 'datetimeOperator') {
                    var type = col.controlType.replace(/Operator$/, '');
                    if (this_1.rec['$operator.$radio.' + k_1] === 'match') {
                        this_1.formatDateTime('$match.' + k_1, type, col);
                        disp = this_1.setPredicate(Object.assign(new ItemBase(), col, { controlType: type }), this_1.rec['$match.' + k_1], this_1.rec['$operator.$match.' + k_1]);
                    }
                    else {
                        var rangeCol = JSOG.parse(JSON.stringify(col));
                        var rangeFromParams = jsonpath.value(rangeCol, '$.params.rangeFrom');
                        var rangeToParams = jsonpath.value(rangeCol, '$.params.rangeTo');
                        if (rangeFromParams) {
                            delete rangeCol.params.rangeFrom;
                        }
                        if (rangeToParams) {
                            delete rangeCol.params.rangeTo;
                        }
                        var rangeFromCol = $.extend(true, new ItemBase(), rangeCol, { params: rangeFromParams });
                        var rangeToCol = $.extend(true, new ItemBase(), rangeCol, { params: rangeToParams });
                        this_1.formatDateTime('$rangeFrom.' + k_1, type, rangeFromCol);
                        this_1.formatDateTime('$rangeTo.' + k_1, type, rangeToCol);
                        var f = this_1.setPredicate(Object.assign(new ItemBase(), rangeFromCol, { controlType: type }), this_1.rec['$rangeFrom.' + k_1], this_1.rec['$operator.$rangeFrom.' + k_1]);
                        var t = this_1.setPredicate(Object.assign(new ItemBase(), rangeToCol, { controlType: type }), this_1.rec['$rangeTo.' + k_1], this_1.rec['$operator.$rangeTo.' + k_1]);
                        disp = f || t;
                    }
                }
                else if (col.controlType === 'select2ajax') {
                    var rec = this_1.rec[k_1];
                    if (rec && rec.code) {
                        rec = rec.code;
                    }
                    disp = this_1.setPredicate(col, rec);
                    if (disp) {
                        var option = this_1.s2Service.getOption(this_1.componentName, k_1);
                        if (option && option.code && option.display && option.code === rec) {
                            this_1.rec[k_1] = option;
                        }
                        else if (this_1.rec[k_1] && this_1.rec[k_1].code && this_1.rec[k_1].display) {
                            // do nothing
                        }
                        else {
                            this_1.s2Service.getOptionFromCode(col.dataType, rec).subscribe(function (option) {
                                if (option) {
                                    _this.rec[k_1] = option;
                                    _this.dispRec = Object.assign({}, _this.rec);
                                    _this.service.setCondition(_this.dispRec, _this.groupName);
                                }
                            });
                        }
                    }
                    //// kts
                }
                else if (col.controlType === 'task') {
                    var sIndex = this_1.predicateList.length;
                    var t1 = this_1.setPredicate(Object.assign(new ItemBase(), col, { key: 'task_u.task_m.step' }), this_1.rec['$' + k_1 + '.task_u.task_m.step']);
                    var t2 = this_1.setPredicate(Object.assign(new ItemBase(), col, { key: 'task_u.task_m.id' }), this_1.rec['$' + k_1 + '.task_u.task_m.id']);
                    var t3 = void 0;
                    var t4 = void 0;
                    if (this_1.rec['$' + k_1 + '.$constructionReport']) {
                        var DATE_DELIMITER_SLASH = moment().toMomentFormatString(this_1.msgSnapshot['au.COMPONENT.DateTimeComponent.option.formatDate']);
                        var DATETIME_DELIMITER_SLASH = moment().toMomentFormatString(this_1.msgSnapshot['au.COMPONENT.DateTimeComponent.option.format']);
                        var from = this_1.rec['$' + k_1 + '.$rangeFrom.task_u.plan_date'];
                        var to = this_1.rec['$' + k_1 + '.$rangeTo.task_u.plan_date'];
                        if (from) {
                            from = moment(from, DATE_DELIMITER_SLASH).format(DATETIME_DELIMITER_SLASH);
                        }
                        if (to) {
                            to = moment(to, DATE_DELIMITER_SLASH).add(1, 'days').add(-1, 'minutes').format(DATETIME_DELIMITER_SLASH);
                        }
                        t3 = this_1.setPredicate(Object.assign(new ItemBase(), col, { key: 'task_u.construction_report.visiting_scheduled_date' }), from, 'ge');
                        t4 = this_1.setPredicate(Object.assign(new ItemBase(), col, { key: 'task_u.construction_report.visiting_scheduled_date' }), to, 'le');
                    }
                    else {
                        t3 = this_1.setPredicate(Object.assign(new ItemBase(), col, { key: 'task_u.plan_date' }), this_1.rec['$' + k_1 + '.$rangeFrom.task_u.plan_date'], 'ge');
                        t4 = this_1.setPredicate(Object.assign(new ItemBase(), col, { key: 'task_u.plan_date' }), this_1.rec['$' + k_1 + '.$rangeTo.task_u.plan_date'], 'le');
                    }
                    var t5 = this_1.setPredicate(Object.assign(new ItemBase(), col, { key: 'task_u.is_complete' }), this_1.rec['$' + k_1 + '.task_u.is_complete']);
                    disp = t1 || t2 || t3 || t4 || t5;
                    var eIndex = this_1.predicateList.length;
                    if (sIndex < eIndex) {
                        var predicates = this_1.predicateList.splice(sIndex, eIndex - sIndex);
                        this_1.predicateList.push(Object.assign(new Predicate(), { and: predicates }));
                    }
                }
                else if (col.controlType === 'constructionClassification') {
                    var c1 = false;
                    var constClass = jsonpath.value(col, '$.params.classification.key');
                    if (constClass) {
                        c1 = this_1.setPredicate(Object.assign(new ItemBase(), col, { key: constClass }), this_1.rec[constClass]);
                    }
                    var c2 = false;
                    var constMiddleClass = jsonpath.value(col, '$.params.middleClassification.key');
                    if (constMiddleClass) {
                        c2 = this_1.setPredicate(Object.assign(new ItemBase(), col, { key: constMiddleClass }), this_1.rec[constMiddleClass]);
                    }
                    disp = c1 || c2;
                }
                else if (col.controlType === 'department') {
                    var c1 = false;
                    var departmentKey = jsonpath.value(col, '$.params.department.key');
                    if (departmentKey) {
                        c1 = this_1.setPredicate(Object.assign(new ItemBase(), col, { key: departmentKey }), this_1.rec[departmentKey]);
                    }
                    var c2 = false;
                    var sectionKey = jsonpath.value(col, '$.params.section.key');
                    if (sectionKey) {
                        c2 = this_1.setPredicate(Object.assign(new ItemBase(), col, { key: sectionKey }), this_1.rec[sectionKey]);
                    }
                    disp = c1 || c2;
                }
                else {
                    this_1.formatDateTime(k_1, col.controlType, col);
                    disp = this_1.setPredicate(col, this_1.rec[k_1]);
                }
            }
            this_1.conddisp.push(disp);
        };
        var this_1 = this;
        for (var _i = 0, _a = this.cols; _i < _a.length; _i++) {
            var col = _a[_i];
            _loop_1(col);
        }
        this.dispRec = Object.assign({}, this.rec);
        this.service.setCondition(this.dispRec, this.groupName);
    };
    KtsSearchComponent.prototype.formatDateTime = function (key, controlType, col) {
        if (!key || !this.rec[key]) {
            return;
        }
        var formats = this.datetimeService.getFormatOptions(col, this.msgSnapshot);
        var format = '';
        if (controlType === 'date') {
            format = formats.formatDate;
        }
        else if (controlType === 'time') {
            format = formats.formatTime;
        }
        else if (controlType === 'datetime') {
            format = formats.format;
        }
        else {
            return;
        }
        var dateTimeKey = "$" + controlType + "." + key;
        if (this.checkDateTime && this.rec[dateTimeKey]) {
            this.rec[key] = flatpickr.formatDate(flatpickr.parseDate(this.rec[dateTimeKey], 'Z'), format);
        }
        else {
            this.rec[dateTimeKey] = flatpickr.formatDate(flatpickr.parseDate(this.rec[key], format), 'Z');
        }
    };
    KtsSearchComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-search',
                    template: "<div class=\"filter\" id=\"{{ componentName }}\">\n  <p class=\"filter_trigger\">\n    <span [class.open]=\"toggle\" (click)=\"switchToggle()\">{{ (msg | async)['SearchConditionComponent.label.title'] }}</span>\n    <i class=\"filter_triggerStatus\" (click)=\"switchToggle()\">{{ (msg | async)['SearchConditionComponent.label.currentCondition'] }}\n      <ng-template [ngIf]=\"predicateList.length > 0\" [ngIfElse]=\"elseBlock\">\n        <ng-template ngFor let-col [ngForOf]=\"cols\" let-index=\"index\">\n          <span *ngIf=\"conddisp[index]\" class=\"filter_triggerStatusItem\">{{ col.label }}\n            <span class=\"filter_triggerStatusItemValue\">\n              <ng-template [ngIf]=\"!col.items\">\n                <ng-container [ngSwitch]=\"col.controlType\">\n                  <!-- kts -->\n                  <kts-column-task-label *ngSwitchCase=\"'task'\" [col]=\"col\" [val]=\"dispRec\" [msg]=\"(msg | async)\"></kts-column-task-label>\n                  <kts-column-construction-classification-label *ngSwitchCase=\"'constructionClassification'\" [componentName]=\"componentName\" [col]=\"col\" [val]=\"dispRec\" [msg]=\"(msg | async)\"></kts-column-construction-classification-label>\n                  <kts-column-department-label *ngSwitchCase=\"'department'\" [componentName]=\"componentName\" [col]=\"col\" [val]=\"dispRec\" [msg]=\"(msg | async)\"></kts-column-department-label>\n                  <!-- ma31 -->\n                  <column-label-operator *ngSwitchCase=\"'textOperator'\" [col]=\"col\" [val]=\"dispRec\" [msg]=\"(msg | async)\"></column-label-operator>\n                  <column-label-operator *ngSwitchCase=\"'numberOperator'\" [col]=\"col\" [val]=\"dispRec\" [msg]=\"(msg | async)\"></column-label-operator>\n                  <column-label-operator *ngSwitchCase=\"'dateOperator'\" [col]=\"col\" [val]=\"dispRec\" [msg]=\"(msg | async)\"></column-label-operator>\n                  <column-label-operator *ngSwitchCase=\"'timeOperator'\" [col]=\"col\" [val]=\"dispRec\" [msg]=\"(msg | async)\"></column-label-operator>\n                  <column-label-operator *ngSwitchCase=\"'datetimeOperator'\" [col]=\"col\" [val]=\"dispRec\" [msg]=\"(msg | async)\"></column-label-operator>\n                  <column-formlabel *ngSwitchDefault [col]=\"col\" [val]=\"dispRec[col.key]\" [msg]=\"(msg | async)\"></column-formlabel>\n                </ng-container>\n              </ng-template>\n              <ng-template ngFor let-item [ngForOf]=\"col.items\">\n                <column-formlabel [col]=\"item\" [val]=\"dispRec[item.key]\" [msg]=\"(msg | async)\"></column-formlabel>\n              </ng-template>\n            </span>\n          </span>\n        </ng-template>\n      </ng-template>\n      <ng-template #elseBlock>\n        <span class=\"filter_triggerStatusItem\">{{ (msg | async)['SearchConditionComponent.label.notSet'] }}</span>\n      </ng-template>\n    </i>\n  </p>\n  <form>\n    <div class=\"filter_property filter_property_toggle -p-1\" [style.display]=\"toggle ? 'block': 'none'\">\n      <ul class=\"filter_property_ul\">\n        <ng-template ngFor let-col [ngForOf]=\"cols\" let-index=\"index\">\n          <li *ngIf=\"col.controlType !== 'task'; else elseBlock\">\n            <column-search [key]=\"'forminline'\" [componentName]=\"componentName\" [col]=\"col\" [val]=\"rec\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event)\"></column-search>\n          </li>\n          <ng-template #elseBlock>\n            <li>\n              <kts-column-task-condition [key]=\"'forminline'\" [componentName]=\"componentName\" [index]=\"index\" [col]=\"col\" [val]=\"rec\" [msg]=\"(msg | async)\" (changeVal)=\"onChange($event)\"></kts-column-task-condition>\n            </li>\n          </ng-template>\n        </ng-template>\n        <li class=\"filter_property_btns -break\">\n          <btn\n              [componentName]=\"componentName + '#Button'\"\n              [component]=\"{\n                params: {\n                  buttons: [\n                    {\n                      type: 'button',\n                      event: componentName + '#Button#search',\n                      caption: (msg | async)['SearchConditionComponent.button.search'],\n                      params: {btnClass: {sm: true}}\n                    }, {\n                      type: 'button',\n                      event: componentName + '#Button#searchClear',\n                      caption: (msg | async)['SearchConditionComponent.button.clear'],\n                      params: {btnClass: {sm: true, type: 'delete'}}\n                    }\n                  ]\n                }\n          }\"></btn>\n        </li>\n      </ul>\n    </div>\n  </form>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    KtsSearchComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ListService },
        { type: ColumnService },
        { type: Select2ajaxService },
        { type: KtsTaskConditionService },
        { type: KtsDateTimeService }
    ]; };
    return KtsSearchComponent;
}(SearchComponent));
export { KtsSearchComponent };
//# sourceMappingURL=search.component.js.map